module.exports = __webpack_public_path__ + "static/photogrammetry_final-2b53e6a1b053d9e5323f0890186ec070.png";